
import * as types from "../constants/action-types";

export default function jobWorkloadReducer(state = [], action) {
    switch (action.type) {
        
        case types.LOGOUT:
            return []
        case types.LOAD_JOBWORKLOAD_SUCCESS:
        
            return action.items;
        
        default:
            return state;
    };
};


